module.exports = __webpack_public_path__ + "6c4a0dbc/img/mini-logo.18817ee5.svg";